import React, { useState, useEffect, useRef } from 'react';
import { Nav, Navbar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import Logo from '../assets/MALogo.svg';
import UserPlaceholder from '../assets/user-placeholder.png'; // Add a placeholder image
import { signOut } from '../auth/authService';
import '../styles/navbar.css';
import ToastNotification from './ToastNotification';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import HamburgerMenu from './landingpage/HamburgerMenu';
import NavbarLoader from './loaders/NavbarLoader';


function ResponsiveAppBar() {
  const [userData, setUserData] = useState(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false); // State to toggle dropdown visibility
  const [serverMessage, setServerMessage] = useState(''); // State to hold server message
  const [showHamburgerMenu, setShowHamburgerMenu] = useState(false); // State for hamburger menu
  const [isLoading, setIsLoading] = useState(true);
  const [processing, setProcessing] = useState(false);
  
  const navigate = useNavigate();
  const dropdownRef = useRef(null); // Ref for the dropdown menu

  // Above useEffect replacement pseudo-code:
  useEffect(() => {
    // check if session is active by checking local storage for user data on session_active key
    const sessionActive = localStorage.getItem('session_active') === 'true';
    const username = localStorage.getItem('username');
    const contributorType = localStorage.getItem('contributorType');
    setIsLoading(false);

    if (sessionActive) {
      setIsLoggedIn(true);
      setUserData({ username: username, contributorType: contributorType });
    } else {
      // force sign out to clear any residual data as a precaution and backup
      signOut();
    }
    
  }, []);

  const toggleDropdown = () => {
    setShowDropdown((prev) => !prev); // Toggle dropdown visibility
  };

  const handleSignOut = async () => {
    setProcessing(true);
    const response = await signOut();
    if (response.success) {
      setIsLoggedIn(false);
      navigate('/');
      setUserData(null);
    } else {
      setServerMessage({ success: false, message: response.message });
    }
    setProcessing(false);
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowDropdown(false); // Hide the dropdown
        setShowHamburgerMenu(false); // Hide hamburger menu
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Disable scrolling when the hamburger menu is shown
useEffect(() => {
  const disableScroll = (event) => {
    event.preventDefault();
  };

  const hamburgerMenuDiv = document.getElementById('hamburger-menu'); // Target the hamburger menu div

  if (showHamburgerMenu) {
    document.body.style.overflow = 'hidden'; // Disable scrolling for the body
    if (hamburgerMenuDiv) {
      hamburgerMenuDiv.style.overflowY = 'scroll'; // Enable vertical scrolling for the menu
    }
    // document.addEventListener('wheel', disableScroll, { passive: false }); // Prevent mouse wheel scrolling outside the menu
    // document.addEventListener('touchmove', disableScroll, { passive: false }); // Prevent touch scrolling outside the menu
  } else {
    document.body.style.overflow = ''; // Enable scrolling for the body
    if (hamburgerMenuDiv) {
      hamburgerMenuDiv.style.overflowY = ''; // Reset scrolling for the menu
    }
    // document.removeEventListener('wheel', disableScroll);
    // document.removeEventListener('touchmove', disableScroll);
  }

  // Clean up on unmount or state change
  return () => {
    document.body.style.overflow = '';
    if (hamburgerMenuDiv) {
      hamburgerMenuDiv.style.overflowY = '';
    }
    // document.removeEventListener('wheel', disableScroll);
    // document.removeEventListener('touchmove', disableScroll);
  };
}, [showHamburgerMenu]);

  return (
    <div className="header">
      <div className="header__left" onClick={() => navigate('/')} style={{ cursor: "pointer" }}>
        <img src={Logo} alt="Melee Academy Logo" />
        <h2 className='ms-3 d-none d-lg-flex' style={{ fontWeight: 600, width: "325px" }}>Melee Academy</h2>
      </div>
      {/* Add the hamburger toggle */}
      <Navbar.Toggle
        aria-controls="responsive-navbar"
        onClick={() => setShowDropdown((prev) => !prev)} // Toggle the dropdown visibility
        className="d-md-none" // Show only on small screens
        style={{
          border: 'none',
          background: 'none',
          outline: 'none',
          cursor: 'pointer',
        }}
      >
        <FontAwesomeIcon icon={faBars} style={{fontSize: '35px'}} onClick={() => setShowHamburgerMenu(true)}/> {/* Custom hamburger icon */}
      </Navbar.Toggle>
      {showHamburgerMenu && (
        <HamburgerMenu setShowHamburgerMenu={setShowHamburgerMenu} isLoggedIn={isLoggedIn} userData={userData} dropdownRef={dropdownRef} handleSignOut={handleSignOut} processing={processing} />
      )}

      {isLoading ? (
        <NavbarLoader />
      ) : (
        <div className="header__right d-none d-md-flex" style={isLoggedIn ? { width: "400px" } : { width: "500px" }}>
          <a href='/tutorials/foundation'>Tutorials</a>
          <a href='/resources'>Resources</a>
          <a href='/pricing'>Pricing</a>
          {isLoggedIn ? (
            <div className="user-menu" ref={dropdownRef}>
              <img
                src={UserPlaceholder}
                alt="User"
                className="user-placeholder"
                onClick={toggleDropdown}
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  cursor: 'pointer',
                }}
              />
              {showDropdown && (
                <div className="custom-dropdown-menu">
                  <div className='flex-row align-items-center ps-3 pt-3'>
                    <p className='microtext'>{userData?.contributorType || "Smash Cadet"}</p>
                    <h4>{userData.username}</h4>
                  </div>
                  <hr style={{ borderColor: "#3C3E4C", borderWidth: "2px", margin: "0" }} />
                  <div className='flex-row align-items-center ps-2 pt-1'>
                    <a href="/profile">Account</a>
                    <a href="/support">Help / Support</a>
                  </div>
                  <hr style={{ borderColor: "#3C3E4C", borderWidth: "2px", margin: "0" }} />
                  <div className='flex-row align-items-center ps-2 pt-1 pb-1'>
                    <button style={{ color: "#FFCC19" }} onClick={handleSignOut} disabled={processing}>Sign Out</button>
                  </div>
                </div>
              )}
            </div>
          ) : (
            <div>
              <button className="header__button" style={{ background: "none", color: "white", paddingRight: "20px" }} onClick={() => navigate('/login')}>Sign In</button>
              <button className="header__button" style={{ background: "#FFCC19", width: "90px", fontWeight: "500", color: "black" }} onClick={() => navigate('/register')}>Join</button>
            </div>
          )}
        </div>
      )}
      <ToastNotification
        message={serverMessage}
        setServerMessage={setServerMessage}
      />
    </div>
  );
}

export default ResponsiveAppBar;